module.exports = "https://portperrypedals.ca/_res/img/garys.38b51ce.png";